export function resolveOpportunityEvaluationStatus(
	opportunityId: number | string,
	opportunityStatus: string | null | undefined,
	opportunityEvaluations: Map<number, string | null>
): string | null {
	const numericOpportunityId = Number(opportunityId)
	if (Number.isFinite(numericOpportunityId) && opportunityEvaluations.has(numericOpportunityId)) {
		return opportunityEvaluations.get(numericOpportunityId) ?? null
	}

	return opportunityStatus ?? null
}
